import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import Icon from "../../../components/icons";
import toast from "react-hot-toast";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useBillComApi } from '../../../store/api/hooks/billComApiHook';
import { showLocalDateTime } from "../../../_common/functions";
import { PAGE_SIZE } from '../../../_common/constant';
import Pagination from "../../../components/pagination";

interface Props {
    onClose: () => void;
    onSelect: (data: any[]) => void;
    item?: any;
};

const BillComMDModalContent: React.FC<Props> = ({ onClose, onSelect, item }) => {
    const billComApi: any = useBillComApi();
    const { showLoader, hideLoader } = useAppLoader();
    const [working, setWorking] = useState<boolean>(false);
    const [vendorRowData, setVendorRowData] = useState<any>(null);
    const [departmentRowData, setDepartmentRowData] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);

    let totalRecords = 0;
    if (item === 'syncVendor') totalRecords = vendorRowData?.totalRecord || 0;
    if (item === 'syncDepartment') totalRecords = departmentRowData?.totalRecord || 0;

    useEffect(() => {
        if (!item) return;

        showLoader();
        setWorking(true);

        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            isLinked: null,
        };

        const onSuccess = (resp: any, setData: Function) => {
            setData(null);
            if (resp.totalRecord>0) {
                setData(resp);
            }
            setWorking(false);
            hideLoader();
        };

        const onError = (error: any) => {
            toast.error(error);
            setWorking(false);
            hideLoader();
        };

        switch (item) {
            case 'syncVendor':
                billComApi.getBillComVendors(payload, (resp: any) => onSuccess(resp, setVendorRowData), onError);
                break;
            case 'syncDepartment':
                billComApi.getBillComDepartments(payload, (resp: any) => onSuccess(resp, setDepartmentRowData), onError);
                break;
            default:
                setWorking(false);
                hideLoader();
                break;
        }
    }, [item, currentPage]);

    console.log(vendorRowData);

    return (
        <div className="modal-box max-w-[90%] w-[50rem] p-4">
            {/* Sticky header */}
            <div className="flex items-center justify-between border-b border-[#8D6E63] pb-2 mb-2 bg-white sticky top-0 z-30">
                <p className="text-[1.063rem] text-[#755B51] font-semibold">Bill.com Sync Log</p>
                <button onClick={onClose} className="bg-primary text-white p-1 rounded-md"><Icon name="close" size={1.25} /></button>
            </div>

            <div className="py-3">
                {!working && totalRecords > PAGE_SIZE && (
                    <div className="flex justify-start mt-4">
                        <Pagination perPage={PAGE_SIZE} totalRecords={totalRecords} onPageChange={setCurrentPage} currentPage={currentPage} />
                    </div>
                )}
                {/* Scrollable data area */}
                <div className="min-h-[300px] max-h-[370px] overflow-auto relative rounded-md border border-gray-300 mt-2">
                    {/* Sticky Table Header */}
                    <div className="flex bg-gray-100 text-xs font-medium text-slate-600 border-b border-gray-300 sticky top-0 z-20">
                        {item === 'syncVendor' && (
                            <>
                                <div className="w-1/3 px-2 py-2">Vendor ID</div>
                                <div className="w-1/3 px-2 py-2">Vendor Name</div>
                                <div className="w-1/3 px-2 py-2">Date and Time Sync</div>
                            </>
                        )}
                        {item === 'syncDepartment' && (
                            <>
                                <div className="w-1/4 px-2 py-2">Department ID</div>
                                <div className="w-1/4 px-2 py-2">Name</div>
                                <div className="w-1/4 px-2 py-2">Short Name</div>
                                <div className="w-1/4 px-2 py-2">Date and Time Sync</div>
                            </>
                        )}
                    </div>

                    {working && (
                        <div className="flex items-center justify-center py-10">
                            <Loader />
                        </div>
                    )}

                    {!working && item === 'syncVendor' && vendorRowData?.results?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/3 px-2 py-2">{row?.id || '-'}</div>
                            <div className="w-1/3 px-2 py-2">{row?.name || '-'}</div>
                            <div className="w-1/3 px-2 py-2">{showLocalDateTime(row?.updatedTime) || '-'}</div>
                        </div>
                    ))}

                    {!working && item === 'syncDepartment' && departmentRowData?.results?.map((row: any, index: number) => (
                        <div key={index} className="flex border-t text-sm text-gray-700">
                            <div className="w-1/4 px-2 py-2">{row?.id || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.name || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{row?.shortName || '-'}</div>
                            <div className="w-1/4 px-2 py-2">{showLocalDateTime(row?.updatedTime) || '-'}</div>
                        </div>
                    ))}

                    {!working && ((item === 'syncVendor' && !vendorRowData?.results?.length) || (item === 'syncDepartment' && !departmentRowData?.results?.length)) && (
                        <div className="p-4 text-center text-gray-400">No data found.</div>
                    )}
                </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 border-t border-[#8D6E63] pt-2">
                <Button type="button" theme="secondary" onClick={onClose}>
                    Close
                </Button>
            </div>
        </div>
    );
};

export default BillComMDModalContent;